import React from "react";

export default function Contacts() {
  return (
    <div className="container text-center my-5">
      <div className="about-text">
        <p>George Falkovich</p>
        <p>Haifa, Israel</p>
        <p>+972546358158</p>
        <p>gfalk85@gmail.com</p>
        <p>www.george-falkovich.com</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Contacts.js